/**
 * THE SHELL THE RAIL AND THE SCREEN SHARE.
 *
 * Before this, the Portal had no shell at all: three routes each rendered a
 * centred column and the only way between them was the browser's back button or
 * a return to the dashboard. That is why the founder's mock-up has a rail —
 * moving from Compliance to Finance was two navigations through a screen you
 * did not want.
 *
 * THE RAIL IS DRAWN ONCE, HERE, AND NOT PER ROUTE. A rail mounted inside each
 * screen would refetch its cards on every navigation, and would flicker out of
 * existence between two screens that both have one. It also keeps its collapsed
 * state across a navigation for free, which a per-route rail could not do
 * without moving that state up here anyway.
 *
 * WHAT THE SHELL FETCHES AND WHAT IT DOES NOT. The rail needs two things the
 * screens were already asking for separately — the permissions this account
 * holds, and the per-card attention counts — so they are asked for once here
 * and handed down. Nothing else moved: each screen still fetches its own work.
 *
 * ON A NARROW SCREEN THE RAIL IS THE COLLAPSED ONE AND THAT IS ALL. A drawer
 * that slides over the content is a different design with its own overlay,
 * focus trap and dismiss behaviour, and the founder asked for a collapse, not a
 * drawer. Below 900px the rail starts collapsed — icons only, 72px — which is
 * the state that already exists and already works. Said plainly rather than
 * built badly.
 */

import { useEffect, useState } from 'react';
import { fetchMyPermissions, fetchPortalAttention } from './lib/portal';
import Rail from './Rail';
import { O } from './ui';

export default function PortalShell({ cards, children }) {
  const [permissions, setPermissions] = useState(null);
  const [attention, setAttention] = useState({});

  useEffect(() => {
    let alive = true;
    fetchMyPermissions().then(({ data }) => { if (alive) setPermissions(data || []); });
    fetchPortalAttention().then(({ data }) => { if (alive) setAttention(data || {}); });
    return () => { alive = false; };
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: '100vh', background: O.canvas }}>
      <Rail cards={cards} permissions={permissions} attention={attention} />
      {/* minWidth: 0 so that a wide table inside a screen makes its own
          container scroll rather than pushing the rail off the left edge —
          the same fix the field onboarding stand carries, for the same
          reason. */}
      <div style={{ flex: 1, minWidth: 0 }}>
        {typeof children === 'function' ? children({ permissions, attention }) : children}
      </div>
    </div>
  );
}
